import React from 'react'
import PropTypes from 'prop-types'
import {
  Header,
  SidebarLockup,
  NavigationToggleButton
} from 'belle-js'

import styles from './PWMHeader.module.scss'

const PWMHeader = (props) => {
  const {
    openNav,
    isMobile
  } = props

  return (
    <div className={styles.PWMHeader}>
      <Header isFixed={true}>
        {isMobile && <NavigationToggleButton onClick={openNav} />}
        <SidebarLockup orientation="horizontal" />
      </Header>
    </div>
  )
}

PWMHeader.defaultProps = {
  isMobile: false,
  openNav () {}
}

PWMHeader.propTypes = {
  isMobile: PropTypes.bool,
  openNav: PropTypes.func
}

export default PWMHeader



// WEBPACK FOOTER //
// ./src/components/Onboarding/PWMHeader/PWMHeader.jsx